import React, { useEffect } from "react";
import { Components, useContentDeliveryAPI } from "@episerver/spa-core";
import { Grid } from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./SplitContentBlock.style";
const SplitContentBlock = (props) => {
    const useContent = useContentDeliveryAPI();
    const [leftBlockMeta, setLeftBlockMeta] = React.useState(null);
    const [rightBlockMeta, setRightBlockMeta] = React.useState(null);
    const classes = useStyles();
    const hasType = (content, type) => content?.contentType?.find((t) => t === type) ? true : false;
    const imageAfterContent = (content) => hasType(content, "TextBlock") && Boolean(content?.moImage?.value) && Boolean(content?.showImageAfterText?.value);
    const hasTextBlockImage = (content) => hasType(content, "TextBlock") && Boolean(content?.moImage?.value);
    if (!props?.data?.leftContent?.value || !props?.data?.rightContent?.value) {
        return null;
    }
    const leftGuid = props.data?.leftContent?.value[0]?.contentLink?.guidValue;
    const rightGuid = props.data?.rightContent?.value[0]?.contentLink?.guidValue;
    useEffect(() => {
        if (!leftGuid || !rightGuid)
            return;
        const fetchBlocks = async () => {
            try {
                const [leftContent, rightContent] = await Promise.all([
                    useContent.getContent(leftGuid),
                    useContent.getContent(rightGuid),
                ]);
                if (leftContent != null && rightContent != null) {
                    setLeftBlockMeta({ type: hasType(leftContent, "WebshopEntryBlock") ? "WebshopEntryBlock" : "TextBlock", hasImage: hasTextBlockImage(leftContent), imageAfterContent: imageAfterContent(leftContent) });
                    setRightBlockMeta({ type: hasType(rightContent, "WebshopEntryBlock") ? "WebshopEntryBlock" : "TextBlock", hasImage: hasTextBlockImage(rightContent), imageAfterContent: imageAfterContent(rightContent) });
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        fetchBlocks();
    }, [leftGuid, rightGuid, useContent]);
    return (React.createElement(Grid, { container: true, className: classes.wrapper, spacing: 2 },
        React.createElement(Grid, { item: true, className: clsx(classes.splitContent, leftBlockMeta?.type === "WebshopEntryBlock" && classes.webshopEntryBlock, leftBlockMeta?.type === "TextBlock" && classes.textBlock, !leftBlockMeta?.hasImage && classes.noImage, leftBlockMeta?.imageAfterContent && classes.imageAfterContent), xs: 12, md: 6 },
            React.createElement(Components.ContentArea, { data: props.data.leftContent, defaultBlockClass: classes.columnBlock })),
        React.createElement(Grid, { item: true, className: clsx(classes.splitContent, rightBlockMeta?.type === "WebshopEntryBlock" && classes.webshopEntryBlock, rightBlockMeta?.type === "TextBlock" && classes.textBlock, !rightBlockMeta?.hasImage && classes.noImage, rightBlockMeta?.imageAfterContent && classes.imageAfterContent), xs: 12, md: 6 },
            React.createElement(Components.ContentArea, { data: props.data.rightContent, defaultBlockClass: classes.columnBlock }))));
};
export default SplitContentBlock;
